/**
 * This file contains important picture functions, like showing the profile picture and default profile picture and to resize uploaded images
 */
import imageCompression from "browser-image-compression";


export const getClientPicture = ({newProfilePicture, clientPicture, clientGender}) =>{
	if (newProfilePicture) {
		return URL.createObjectURL(newProfilePicture);
	}
	if (clientPicture) {
		return clientPicture;
	}
	if (clientGender === "weiblich") {
		return require("../assets/client_female.svg");
	}
	else if( clientGender === "männlich"){
		return require("../assets/client_male.svg");
	}else{
		return require("../assets/profile - d.svg");
	}
}

export const getUserPicture = ({newProfilePicture, userPicture, userGender}) =>{
	if (newProfilePicture) {
		return URL.createObjectURL(newProfilePicture);
	}
	if (userPicture) {
		return userPicture;
	}
	if (userGender === "weiblich") {
		return require("../assets/user_female.svg");
	}
	else if( userGender === "männlich"){
		return require("../assets/user_male.svg");
	}else{
		return require("../assets/profile - user - d.svg");
	}
}

export const maxPictureSize = 512;

export async function resizeImage(value, max = maxPictureSize) {
	const compressed = await imageCompression(value, {
		maxSizeMB:         1,
		maxWidthOrHeight:  max,
		fileType:          "image/jpeg",
		useWebWorker:      true
	});
	const dataUrl = await imageCompression.getDataUrlFromFile(compressed);
	return dataUrl.split("base64,")[1];
}
